import API from '../../sunwiseAPI';
const ENTITY = 'project-configuration';

export const getData = (projectId, report) =>
    API.get(`/api/v1/${ENTITY}/${projectId}/sunpay`, { params: { report } });
